import { TableCell, TableHead, TableRow } from '@material-ui/core';
import React, { FunctionComponent, useState } from 'react';
import NotificationAdditionalArgs from '../../../../../Types/Interface/TableInterfaces/AdditionalArgsInterface/NotificationAdditionalArgs';
import NotificationInterface from '../../../../../Types/Interface/TableInterfaces/DataInterface/NotificationInterface';
import ListHeaderProps from '../../../../../Types/Interface/Props/ListHeaderProps';
import GetHandleFilter from '../../../../../Methods/TableQuery/HandleFilter/GetHandleFilter';
import { HeadCell } from '../../../../../Types/BeecomingTypes/BeecomingTypes';
import SearchBox from '../../SearchBox';
import ListHeaderOrder from './ListHeaderOrder';

const ListHeaderNotification: FunctionComponent<
  ListHeaderProps<NotificationInterface, NotificationAdditionalArgs>
> = ({
  additionalArgs,
  onChangeAdditionalArgs,
  orderType,
  onChangeOrderType,
  orderBy,
  onChangeOrderBy = () => new Promise<boolean>(() => true),
}) => {
  const [timer, setTimer] = useState(setTimeout(() => {}, 0));

  const headCells: HeadCell<NotificationInterface>[] = [
    { id: 0, keyValue: 'title', name: 'Notification', align: 'left' },
    { id: 1, keyValue: 'body', name: 'Texte de la notification', align: 'left' },
    { id: 2, keyValue: 'sendingTime', name: 'Jour', align: 'left' },
    { id: 3, keyValue: 'sendingTime', name: "Heure de l'envoi", align: 'left' },
    { id: 4, keyValue: 'id', name: '', align: 'left' },
  ];
  return (
    <TableHead>
      <TableRow>
        <TableCell>
          <SearchBox
            label="Rechercher"
            handleSearch={GetHandleFilter<NotificationAdditionalArgs>(
              'title',
              additionalArgs,
              onChangeAdditionalArgs,
              timer,
              setTimer,
              500,
            )}
          />
        </TableCell>
        <TableCell />
        <TableCell />
        <TableCell />
        <TableCell />
      </TableRow>
      <ListHeaderOrder<NotificationInterface>
        headCells={headCells}
        orderType={orderType}
        onChangeOrderType={onChangeOrderType}
        orderBy={orderBy}
        onChangeOrderBy={onChangeOrderBy}
      />
    </TableHead>
  );
};

export default ListHeaderNotification;
